import { render } from "./ThongTinSoatVeChuyenDiTruoc.vue?vue&type=template&id=4006de92"
import script from "./ThongTinSoatVeChuyenDiTruoc.vue?vue&type=script&lang=js"
export * from "./ThongTinSoatVeChuyenDiTruoc.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__